'use strict';

import * as promotionList from '../actions/promotionList';

var defaultState = {
    promotions: [],
    isNewPromoCodeOverlayOpen: false,
    isDeletePromoCodeOverlayOpen: false,
    promotionToDelete: null,
    promotionToEdit: null
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case promotionList.HIDE_EDIT_PROMO_CODE_OVERLAY:

            return {
                ...state,
                promotionToEdit: null
            };

        case promotionList.SHOW_EDIT_PROMO_CODE_OVERLAY:

            return {
                ...state,
                promotionToEdit: action.promotion
            };

        case promotionList.HIDE_DELETE_PROMO_CODE_OVERLAY:

            return {
                ...state,
                isDeletePromoCodeOverlayOpen: false,
                promotionToDelete: null
            };

        case promotionList.SHOW_DELETE_PROMO_CODE_OVERLAY:

            return {
                ...state,
                isDeletePromoCodeOverlayOpen: true,
                promotionToDelete: action.promotion
            };

        case promotionList.SHOW_NEW_PROMO_CODE_OVERLAY:

            return {
                ...state,
                isNewPromoCodeOverlayOpen: true
            };

        case promotionList.HIDE_NEW_PROMO_CODE_OVERLAY:

            return {
                ...state,
                isNewPromoCodeOverlayOpen: false
            };

        case promotionList.PROMOTIONS_REFRESHED:

            return {
                ...state,
                promotions: action.promotions
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/promotionList.js